module.exports = __webpack_public_path__ + "static/img/industry_retail.584ad8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/industry_retail.jpg
// module id = WnJo
// module chunks = 0